import React, { useEffect, useState } from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { ComingSoon } from "../../helper/Backgrounds";
import { Link, useLocation } from "react-router-dom";

const data = [
  {
    name: "/team",
    title: "Team",
    titleText: "Create your team and get things done together.",
    descriptionText:
      "Unlock effortless maintenance scheduling! Keep your systems running smoothly with planned or unexpected maintenance — no alerts sent during maintenance windows.",
  },
  {
    name: "/cluster",
    title: "Cluster",
    titleText: "Organize your uptime monitors into powerful clusters!",
    descriptionText:
      "Unlock the power of clustering! Monitor multiple servers in one view to keep your uptime seamless and organized. Manage all your uptime checks effortlessly in one place.",
  },
];

const PackageAlert = () => {
  const location = useLocation();
  const [selectData, setSelectData] = useState();
  const theme = useTheme();
  const background = theme.palette.secondary.backgroundVis;

  useEffect(() => {
    let found = data.find((e) => e.name == location?.pathname);
    setSelectData(found);
    document.title = `${found?.title} | Statusnap`;
  }, [location]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: window.innerHeight / 1.3,
        textAlign: "center",
        padding: 3,
      }}
    >
      <Typography variant="h4" sx={{ color: "white", mb: 1, fontWeight: 600 }}>
        {selectData?.titleText}
      </Typography>
      <Typography variant="body1" sx={{ color: "white", mb: 2, maxWidth: 600 }}>
        {selectData?.descriptionText}
      </Typography>
      <Button
        component={Link}
        to="/pricing"
        sx={{
          color: "#e0e0e0",
          backgroundColor: background,
          borderColor: "#007A33",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.35)",
          transition: "background-color 0.3s ease, transform 0.2s ease",
          margin: "3px 0 3px 3px",
          mt: 2,
          px: 4,
          py: 1.5,
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "#007A33",
            borderColor: "#007A33",
          },
          "&:active": {
            backgroundColor: "#007A33",
            transform: "scale(0.98)",
          },
        }}
      >
        See Plans
      </Button>
      <ComingSoon />
    </Box>
  );
};

export default PackageAlert;
